import DialogContent from '@mui/material/DialogContent';
import Divider from '@mui/material/Divider';
import type { UseUserCreate } from '@openx/components-administration/lib/utils/context/UserHookTypes.ts';
import { useConfirmationDialog } from '@openx/components-core/lib/Dialog/ConfirmationDialog/useConfirmationDialog.tsx';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { CreateUserModalForm } from '../components/CreateUserModalForm.tsx';

export type UseUserCreateModalProps = {
  handleCreateUser: ReturnType<UseUserCreate>['createUser'];
  organizationId: string;
};

export const useUserCreateModal = ({ handleCreateUser, organizationId }: UseUserCreateModalProps) => {
  const { t } = useTranslation();
  const { open } = useConfirmationDialog();

  return useCallback(() => {
    open({
      cancelLabel: t('Close'),
      confirmationButtonColor: 'primary',
      hideConfirm: true,
      confirmationLabel: t('Close'),
      content: (
        <>
          <DialogContent dividers sx={{ mb: 6 }}>
            <CreateUserModalForm handleCreateUser={handleCreateUser} organizationId={organizationId} />
          </DialogContent>
          <Divider />
        </>
      ),
      customContent: true,
      title: t('Add User'),
    });
  }, [handleCreateUser, open, t, organizationId]);
};
